import { Component, Input } from '@angular/core';
import {
  BasketItem,
  EnterpriseSearchService,
  CarHireVehicleAvailibility,
  ModalOpenerService
} from '@sabstravtech/obtservices/angular';
import { BehaviorSubject } from 'rxjs';

import { CarDetailsComponent } from '../car-details/car-details.component';

@Component({
  selector: 'app-basket-car-details',
  templateUrl: './basket-car-details.component.html',
  styleUrl: './basket-car-details.component.scss',
  standalone: false
})
export class BasketCarDetailsComponent extends CarDetailsComponent {
  @Input() car: BasketItem;
  @Input() hideIcon = false;
  public carDetailLoadingStates: BehaviorSubject<boolean>[] = [];

  constructor(
    protected searchService: EnterpriseSearchService,
    protected modalService: ModalOpenerService
  ) {
    super(modalService, searchService);
  }

  getCarDetails(car: BasketItem): void {
    const result: CarHireVehicleAvailibility = {
      co2PerItem: car.co2PerItem,
      co2PerPassenger: car.co2PerPassenger,
      displayRecord: {
        dropoff: car.detail.dropOffDatetime,
        pickup: car.detail.pickUpDatetime,
        pickupLocation: {
          ...car.detail.pickUpLocation,
          topLine: car.detail.pickUpLocation.address
        },
        price: car.price,
        returnLocation: {
          ...car.detail.dropOffLocation,
          topLine: car.detail.dropOffLocation.address
        },
        vehicle: {
          class: car.detail.car.class,
          transmission: car.detail.car.manualTransmission,
          type: car.detail.car.type
        },
        vendor: {
          name: car.detail.vendorName,
          vendorCode: car.detail.identifiers.vendor
        },
        rateCode: car.detail.identifiers.rateCode
      },
      fareInfo: car.detail.fareInfo,
      identifiers: {
        ...car.detail.identifiers,
        pickUpDateTime: car.detail.pickUpDatetime,
        dropOffDateTime: car.detail.dropOffDatetime
      },
      source: car.service.name,
      sourceId: +car.service.id,
      officePreferred: null,
      companyPreferred: null,
      tmcPreferred: null,
      unavailable: null
    };
    this.getCarHireAvailabilityDetail(result);
  }
}
